import usePageMeta from "utils/usePageMeta";
// @mui material components

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Reusable Components

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import ContactUs_Section1 from "./sections/ContactUs_Section1";

function ContactUs() {
  usePageMeta({
    title: "Contact Us | Spechs Ireland",
    description:
      "Get in touch with Spechs for cleaning, property management, or workforce solutions. We're here to help.",
    canonical: "https://www.spechs.ie/contact-us/",
  });
  return (
    <SubPageLayout title="Contact Us">
      <MKBox component="section" py={{ xs: 3, md: 5 }}>
        <ContactUs_Section1 />
      </MKBox>
      {/* <MKBox component="section" py={{ xs: 3, md: 5 }}>
        <ContactUs_Section2 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <ContactUs_Section3 />
      </MKBox>
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <ContactUs_Section4 />
      </MKBox> */}
    </SubPageLayout>
  );
}

export default ContactUs;
